import { render, staticRenderFns } from "./MyProducts.vue?vue&type=template&id=16abcc54&scoped=true"
import script from "./MyProducts.vue?vue&type=script&lang=js"
export * from "./MyProducts.vue?vue&type=script&lang=js"
import style0 from "./MyProducts.vue?vue&type=style&index=0&id=16abcc54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16abcc54",
  null
  
)

export default component.exports